import React from 'react';

import styles from './MaintenanceScreen.module.scss';

const MaintenanceScreen = () => (
  <div className={styles.maintenance}>
    <span>
      We&apos;re currently offline for essential maintenance.
      <br />
      We&apos;ll be back shortly.
    </span>
  </div>
);

export default MaintenanceScreen;
